import { useState } from "react"
import { supabase } from "../supabaseClient"
import { Button, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Input } from "../components/ui"

function LoginPage() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const getURL = () => {
    let url = window.location.origin
    url = url.endsWith("/") ? url : `${url}/`
    return url
  }

  const handleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: getURL(),
      },
    })
  }

  const handleEmailSignIn = async () => {
    setError("")
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    if (error) setError(error.message)
  }

  const handleEmailSignUp = async () => {
    setError("")
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: getURL(),
      },
    })
    if (error) setError(error.message)
  }

  return (
    <div className="ui-auth-layout">
      <Card className="ui-auth-card">
        <CardHeader>
          <CardTitle>Sign in to TuneUp</CardTitle>
          <CardDescription>
            Use your TuneUp credentials or Google account to continue.
          </CardDescription>
        </CardHeader>
        <CardContent className="ui-stack ui-stack--md">
          <Input
            type="email"
            label="Email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <Input
            type="password"
            label="Password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {error && <p className="ui-error">{error}</p>}
        </CardContent>
        <CardFooter className="ui-stack ui-stack--md">
          <div className="ui-button-row ui-button-row--stretch">
            <Button onClick={handleEmailSignIn}>Sign in</Button>
            <Button variant="outline" onClick={handleEmailSignUp}>
              Create account
            </Button>
          </div>
          <div className="ui-divider">
            <span>Or</span>
          </div>
          <Button variant="secondary" fullWidth onClick={handleLogin}>
            Sign in with Google
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}

export default LoginPage
